import { useEffect, useState } from 'react';

import { logError } from '@/common/utils/sharedUtils';

export interface UseVwoTestProps {
  variant: string | null;
  isLoading: boolean;
}

export interface VwoTest {
  name: string;
  variation: string;
}

const storeTestVariation = (test: VwoTest) => {
  window.sessionStorage.setItem(test.name, test.variation);
};
const getStoredTestVariation = (vwoTestName: string): string | null => {
  return window.sessionStorage.getItem(vwoTestName);
};

export const useVwoTest = (testName: string): UseVwoTestProps => {
  const [isLoading, setIsLoading] = useState(true);
  const [testVariant, setTestVariant] = useState<string | null>(null);

  const handleSetTestVariant = (variant: string | null) => {
    setTestVariant(variant);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!window.vwo_testsInit) {
      logError('VWO is not initialized');
    }

    const storedTestVariation = getStoredTestVariation(testName);

    const onSuccess = (test: VwoTest) => {
      storeTestVariation(test);
      handleSetTestVariant(test.variation);
    };

    const onFailure = () => {
      handleSetTestVariant(null);
    };

    if (storedTestVariation) {
      handleSetTestVariant(storedTestVariation);
    } else {
      window.vwo_addTestHandler(testName, onSuccess, onFailure);
    }
  }, [testName]);

  return { variant: testVariant, isLoading };
};
